import { lazy } from 'react';
const RewardTabForm = lazy(() => import('../../views/Settings/Rewards/RewardsTab/RewardTabForm'));

const RewardSettingsRoutes = [
    {
        path: '/add',
        name: 'Add Reward',
        exact: true,
        component: RewardTabForm,
    },
    {
        path: '/edit/:id',
        name: 'Edit Reward',
        exact: true,
        component: RewardTabForm,
    },
];
export default RewardSettingsRoutes;
